import { getRequest } from '@/core';
import { edi } from '@/requests';

export default async function(orderId) {
	let path = edi.getEdiLogsPath(orderId);
	let response = await getRequest(path);
	return response;
}